import { render } from "./ConfigIndex.vue?vue&type=template&id=30c1e0fb&scoped=true"
import script from "./ConfigIndex.vue?vue&type=script&lang=js"
export * from "./ConfigIndex.vue?vue&type=script&lang=js"

import "./ConfigIndex.vue?vue&type=style&index=0&id=30c1e0fb&scoped=true&lang=css"

import exportComponent from "/Users/home/Projects/creelayer/mosquito/mosquito.web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c1e0fb"]])

export default __exports__